import { get } from './get';

export const automationBlockers = {
  get,
};
